<template>
  <v-card flat class="ma-auto pa-0" dense width="98%">
    <b>JURISDICTION: {{ matter.jdxState }}</b>
    <v-expand-transition class="ma-auto pa-0">
      <div>
        <div v-for="(statute, i) in statutes" :key="i">
          <v-card flat class="ma-auto" dense width="90%">
            <v-card-text class="title">
              <v-row>
                <div>{{ statute.title }}</div>
              </v-row>
              <v-row>
                <div v-for="(paragraph, i) in statute.paragraphs" :key="i">
                  <!-- <v-text-field 
              dense
              v-model=""
              outlined
              color="#18cae6"
              ></v-text-field> -->
                  <p>{{ statute.paragraphs[i] }}</p>
                  <div>
                    {{ statute.citation }}
                  </div>
                  <v-checkbox
                    label="include"
                    :value="statute"
                    v-model="selectedStatutes"
                  ></v-checkbox>
                  <v-container>
                    <div v-if="statute.citation === 'Cal. Evid. Code § 669(a)'">
                      <div v-for="(code, i) in codes" :key="i">
                        <v-layout row wrap>
                          <div>{{ code }}</div>
                          <v-spacer></v-spacer>
                          <div>
                            <v-btn
                              small
                              color="red"
                              rounded
                              outlined
                              @click="removeCode(i)"
                              >remove</v-btn
                            >
                          </div>
                        </v-layout>
                      </div>
                    </div>
                  </v-container>
                </div>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
        <div v-for="law in caseLaw" :key="law.citation">
          <v-card
            style="border: 2px solid black; width: auto;  overflow:auto;"
            class="ma-1"
            dense
          >
            <v-card-text class="subtitle-2">{{ law.title }}</v-card-text>
            <div v-for="(parag, i) in law.paragraphs" :key="i">
              <!-- <v-text-field 
              dense
              v-model=""
              outlined
              color="#18cae6"
              ></v-text-field> -->
              <p class="caption">"{{ law.paragraphs[i] }}"</p>
            </div>
            <div class="caption">
              <span style="font-style: italic">{{ law.caseName }}</span
              >{{ ` ${law.citation}.` }}
            </div>

            <v-checkbox
              label="include"
              :value="law"
              v-model="selectedCaseLaw"
            ></v-checkbox>
          </v-card>
        </div>
      </div>
    </v-expand-transition>
    <v-btn @click="logSelectedStatutes">log statutes</v-btn>
    <v-dialog
      v-model="violationDialog"
      max-width="600px"
      style=" border-radius: 26px;"
    >
      <v-card
        class="ma-auto pa-2"
        flat
        filled
        style="
                  border-radius: 26px;
                  border: 1px solid #18CAE6;
                  max-width: 600px;
                  
                "
      >
        <v-card-title>WHAT CODES WERE VIOLATED?</v-card-title>
        <v-form @submit.prevent="addCode" class="ma-auto">
          <v-text-field
            class="ma-2"
            autofocus
            outlined
            v-model="codeName"
            multiple
            label="INPUT CODE CITATION"
            dense
            filled
            color="#2E5473"
          ></v-text-field>
          <v-textarea
            class="ma-2 "
            outlined
            v-model="codeText"
            multiple
            label="INPUT THE CODE TEXT"
            dense
            filled
            color="#2E5473"
          ></v-textarea>
          <v-card-actions class="ma-2">
            <v-spacer></v-spacer>
            <v-btn rounded text outlined @click="violationDialog = false"
              >DONE</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn rounded type="submit">ADD</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
/**
 *
 *
 *
 * this component takes some props and responds with a list of codes???
 *
 *
 *
 */
// import * as moment from "moment";
// import * as firebase from "firebase";

export default {
  props: ["cause", "matter"],
  data() {
    return {
      statutes: [],
      caseLaw: [],
      secondarySources: [],
      showStatutes: false,
      selectedStatutes: [],
      selectedCaseLaw: [],
      violationDialog: false,
      codeName: null,
      codeText: null,
      codes: []
    };
  },
  computed: {
    //if request = negligence
    //respons =
    //primary sources
    //
  },
  watch: {
    selectedStatutes(val) {
      // if (val.length > 0) {
      this.$emit("selected-statutes", this.selectedStatutes);
      this.$emit("reload-doc");
      // }
      if (val.find(stat => stat.citation === "Cal. Evid. Code § 669(a)")) {
        console.log("found");
        this.violationDialog = true;
      }
    },
    selectedCaseLaw() {
      // if (val.length > 0) {
      this.$emit("selected-case-law", this.selectedCaseLaw);
      this.$emit("reload-doc");
      // }
    }
  },
  methods: {
    addCode() {
      this.codes.push(`${this.codeName} - ${this.codeText}`);
      this.$emit("code-violations", this.codes);
      this.$emit("reload-doc");
      this.codeName = null;
      this.codeText = null;
    },
    removeCode(i) {
      this.codes.splice(i, 1);
    },
    logSelectedStatutes() {
      console.log("selected statutes", this.selectedStatutes);
      console.log("selected caseLaw", this.caseLaw);
    }
  },
  created() {
    console.log("props from code selector", this.$props);
    if (this.cause === "NEGLIGENCE" && this.matter.jdxState === "CALIFORNIA") {
      this.statutes.push(
        {
          citation: "Cal. Civ. Code § 1714(a)",
          title: "Negligence - Essential Factual Elements",
          juryIstructions: ["400"],
          paragraphs: [
            "Everyone is responsible, not only for the result of his or her willful acts, but also for an injury occasioned to another by his or her want of ordinary care or skill in the management of his or her property or person..."
          ]
        },
        {
          citation: "Cal. Evid. Code § 669(a)",
          title: "Presumption of Negligence Per Se",
          juryIstructions: ["418", "419"],
          paragraphs: [
            "Failure to exercise due care is presumed if: (1) a party violates a statute; (2) the violation proximately caused injury to another person; (3) the injury resulted from an occurrence of the nature that the statute was designed to prevent; (4) the person suffering the injury was one of the class of people for whose protection the statute was designed."
          ]
        }
      );
    }
    if (
      this.cause === "PREMISE LIABILITY" &&
      this.matter.jdxState === "CALIFORNIA"
    ) {
      this.statutes.push({
        citation: "Cal. Civ. Code § 1714(a)",
        title: "Negligence - Essential Factual Elements",
        juryIstructions: ["400"],
        paragraphs: [
          "Everyone is responsible, not only for the result of his or her willful acts, but also for an injury occasioned to another by his or her want of ordinary care or skill in the management of his or her property or person..."
        ]
      });
      this.caseLaw.push({
        caseName: "Brooks v. Eugene Burger Management Corp.",
        citation: "215 Cal.App.3d 1611, 1619 (1989)",
        title: "Premise Libility - Essential Factual Elements",
        juryIstructions: ["1000"],
        paragraphs: [
          "The owner of premises is under a duty to exercise ordinary care in the management of such premises in order to avoid exposing persons to an unreasonable risk of harm. A failure to fulfill this duty is negligence."
        ]
      });
    }
    if (
      this.cause ===
        "Physical Pain, Mental Suffering, and Emotional Distress" &&
      this.matter.jdxState === "CALIFORNIA"
    ) {
      this.caseLaw.push(
        {
          caseName: "Bigler-Engler v. Breg, Inc.",
          citation: "7 Cal.App.5th 276, 300 (2017)",
          title:
            "Physical Pain, Mental Suffering, and Emotional Distress (Noneconomic Damage)",
          juryIstructions: ["3905A"],
          paragraphs: [
            "[N]oneconomic damages do not consist of only emotional distress and pain and suffering. They also consist of such items as invasion of a person’s bodily integrity (i.e., the fact of the injury itself), disfigurement, disability, impaired enjoyment of life, susceptibility to future harm or injury, and a shortened life expectancy."
          ]
        },
        {
          caseName:
            "Crisci v. The Security Insurance Co. of New Haven, Connecticut ",
          citation: "66 Cal.2d 425, 433 (1967)",
          title:
            "Physical Pain, Mental Suffering, and Emotional Distress (Noneconomic Damage)",
          juryIstructions: ["3905A"],
          paragraphs: [
            "The general rule of damages in tort is that the injured party may recover for all detriment caused whether it could have been anticipated or not. In accordance with the general rule, it is settled in this state that mental suffering constitutes an aggravation of damages when it naturally ensues from the act complained of, and in this connection mental suffering includes nervousness, grief, anxiety, worry, shock, humiliation and indignity as well as physical pain."
          ]
        },
        {
          caseName: "Hillard v. A.H. Robbins Co.",
          citation: "148 Cal.App.3d 374, 196 Cal.Rptr. 117, 142 (1983)",
          title:
            "Physical Pain, Mental Suffering, and Emotional Distress (Noneconomic Damage)",
          juryIstructions: ["3905A"],
          paragraphs: [
            "Pain and suffering are detriment factors for which the injured plaintiff(s) must be compensated if the detriment factors are caused by defendant(s)’ conduct."
          ]
        },

        {
          caseName: "Beagle v. Vasold",
          citation: "65 Cal.2d. 166, 178 (1966)",
          title:
            "Physical Pain, Mental Suffering, and Emotional Distress (Noneconomic Damage)",
          juryIstructions: ["3905A"],
          paragraphs: [
            "A per diem argument, i.e., a certain monetary amount for each day plaintiff(s) suffers from the pain and suffering as a result of the injuries sustained, is proper."
          ]
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
